import Vue from 'vue'
import VueMask from 'v-mask'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import req from "@/plugins/requests"
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import './sclibFilters.js'

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.axios = axios
Vue.prototype.ws = null

Vue.prototype.req = req

Vue.use(VueMask);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
